import React, { useEffect } from 'react'
// import { useNavigate } from 'react-router-dom';
import config from "src/config/config";
import { withAppContext } from 'src/store/initAppContext'
import styled, { withTheme } from 'styled-components'
import { theme } from 'styled-tools';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';

const WorldCupDoubleCashBackCrypto = (props) => {
    const {
        app: { brandId },
        theme,
    } = props;

    // const navigate = useNavigate()
    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, []);

    // const domain = brandId == 61 ? "Yolo247" : "Website";

    return (
        <>
            <MainWrapper>
                <ContentWrapper>
                    <BonusTitle className='textCenter'>
                        <h1>DAILY DELIGHTFUL DEPOSIT BONUS</h1>
                    </BonusTitle>
                    <TitleText>
                        <p>Deposit seven days a week and receive up to a <span className='yellow'>6%</span> Daily Deposit Bonus. This bonus acknowledges players who consistently deposit on our site.</p>
                    </TitleText>
                    <CashBackWrapper>
                        <LeftImgContent>
                            <LazyLoadImage src={`${config.imageV3Host}/static/cashsite/${theme.image.WorldCupDoubleCashBackMobileImage}`} effect="none" placeholder={<PlaceholderImage />} />
                        </LeftImgContent>
                        <BorderLine></BorderLine>
                        <RightTextContent>
                            <BonusTitle>
                                <h3>How Does it Work&#63;</h3>
                            </BonusTitle>
                            <BonusBody>
                                <BonusContent>
                                    <ul>
                                        <li>Add Money&#58;
                                            <span>Add money to your wallet daily - Monday to Sunday.</span>
                                        </li>
                                        <li>Ensure&#58;
                                            <span>Ensure all deposits are successful.</span>
                                        </li>
                                        <li>Bonus Added&#58;
                                            <span>The bonus is instantly added to your Yolo247 Wallet every Monday.</span>
                                        </li>
                                    </ul>
                                </BonusContent>
                            </BonusBody>
                        </RightTextContent>
                    </CashBackWrapper>
                    <Divider></Divider>
                    <TermsAndCondition>
                        <h4>Terms & Conditions</h4>
                        <ul>
                            <li>This offer is valid for users registered on our site.</li>

                            <li>The bonus amount is credited to your wallet every Monday, provided a user has deposited on all seven days of the week.</li>

                            <li>The bonus amount is capped at $50.</li>

                            <li>The bonus amount is not withdrawable. However, Winnings are withdrawable.</li>

                            <li>This offer is not valid with any other offers or promotions on our site. We reserve the right to amend, suspend, or cancel the offer at any time without prior notice.</li>

                            <li>We reserve the right to amend, suspend, or cancel the offer at any time without prior notice.</li>

                            <li>We reserve the right to exclude any user from availing of this offer if found violating fair play.</li>

                            <li>These Terms and Conditions are subject to our General Terms and Conditions and the General Bonus Terms and Conditions.</li>
                        </ul>
                    </TermsAndCondition>
                </ContentWrapper>
            </MainWrapper>
        </>
    )
}

export default withTheme(withAppContext(WorldCupDoubleCashBackCrypto));

//Styled Components

const MainWrapper = styled.div`
    width: 98%;
    height: auto;
    border: 1px solid white;
    border-top: 0;
    display: flex;
    border-radius: 1px;
    background: rgba(111, 111, 111, 0.5);
    margin: 0em 1.2em;
    -webkit-backdrop-filter: brightness(0.5);
    backdrop-filter: brightness(0.5);
`;

const ContentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.WorldCupDoubleCashBackBackground")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    padding: 2rem;
    padding-top: 4rem;

    .lazy-load-image-background {
      display: flex !important;
      justify-content: center !important;
    }

    .secondTitle {
        padding-top: 2rem;
    }

    .textCenter {
        justify-content: center;
    }

    & h4 {
        background: linear-gradient(180deg, #FAE74F 0%, #BA5901 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }

    & h3 {
        background: linear-gradient(180deg, #FAE74F 0%, #BA5901 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: left;
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const TitleText = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 73%;

    p {
        color: #FFF;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize;
    }
    .blue {
        color: #6F6DE6;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
    .yellow {
        background: linear-gradient(180deg, #FAE74F 0%, #BA5901 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: 700;
    }
`;

const CashBackWrapper = styled.div`
    display: flex;
    padding: 2rem 8rem;
    width: 100%;
    justify-content: stretch;
    align-items: center;
`;

const LeftImgContent = styled.div`
    display: flex;
    width: 40%;
    text-align: right;
    justify-content: center;
    align-items: flex-end;

    img {
        width: 55%;
        align-self: flex-end;
    }
`;

const BorderLine = styled.div`
    width: 2px;
    background: linear-gradient(transparent, #B28C04, transparent);
    height: 70%;
    align-self: center;
`;

const RightTextContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 60%;
    background: radial-gradient(circle at left, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 20%);
    padding: 1rem 1rem 1rem 4rem;
    height: 70%;
`;

const BonusTitle = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    background: linear-gradient(180deg, #FAE74F 0%, #BA5901 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    width: 80%;

    h1 {
        font-size: 28px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
    }
`;

const BonusBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
`;

const BonusContent = styled(BonusBody)`
    width: 90%;

    h1 {
        background: linear-gradient(180deg, #FAE74F 0%, #BA5901 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: capitalize;
        margin-bottom: 0;
    }
    p {
        color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-transform: capitalize; 
        padding-left: 1rem;
    }

    & ul {
        padding-left: 2%;
        margin: 5px 0px;
        display: flex;
        flex-direction: column;
        gap: 1.4rem;

        & li {
            gap: 5px;
            color: #e1af31;
            font-size: 14px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            text-transform: capitalize; 
            padding-left: 1rem;
            list-style-type: decimal;

            span {
                color: #FFF;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-transform: capitalize;
                display: block;
                padding-top: 7px;
            }
        }
    }
`;

const Divider = styled.div`
    height: 2px;
    width: 100%;
    background: radial-gradient(#B28C04 0%, #00000000 50%);
`;

const TermsAndCondition = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2rem;
    background: radial-gradient(38.26% 45.18% at 50% 0%, rgba(239, 205, 65, 0.12) 0%, rgba(2, 13, 2, 0.00) 100%);
    width: 65%;
    position: relative;

    & li {
        color: #FFF;
        text-align: justify;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px; /* 116.667% */
        text-transform: capitalize;
        list-style-type: decimal;
        padding-bottom: 1.5rem;
    }

    ::after {
        content: "";
        width: 227px;
        height: 183px;
        background: url(${config.imageV3Host}/static/cashsite/brand/6/image/crypto_BgBall.png);
        background-position: top;
        background-size: cover;
        background-repeat: no-repeat;
        position: absolute;
        right: -24%;
        top: -13%;
    }
`;
